import { realityId } from "@/utils/reality-id";
import api from "../api";
import { invalidateRegistrationProgressQueries } from "../inscription/invalidateRegistrationProgressQueries";
import { CompletedCourses, Course, CourseStatus } from "./types/course.types";

/**
 * Dev/QA: listagem mockada para testar o embed `sg-pdc-web-reality` com um `courseId`
 * que exista no `sg-pdc-api` (ajuste `VITE_MOCK_PDC_COURSE_ID` ao ID real do banco).
 */
function getMockCourses(): Course[] {
  const rawId = import.meta.env.VITE_MOCK_PDC_COURSE_ID;
  const courseId = Number(rawId);
  const id = Number.isFinite(courseId) && courseId > 0 ? courseId : 1;
  return [
    {
      title: `Curso PDC #${id} (mock)`,
      thumbnailUrl: "/assets/icons/quiz.svg",
      /** Path dentro do PDC web (base `/course/`): rota `/courses/:id` */
      courseUrl: `courses/${id}`,
      examPoints: undefined,
      coursePoints: undefined,
      status: CourseStatus.PENDING,
      points: 0,
    },
  ];
}

export const getCourses = async (): Promise<Course[] | undefined> => {
  if (import.meta.env.VITE_USE_MOCK_COURSES === "true") {
    return getMockCourses();
  }
  const res = await api.get(`/realities/${realityId}/courses`);
  return res.data.data;
};

export const getCourseDetails = async (): Promise<string> => {
  const res = await api.get(`/realities/${realityId}/courses/potato`);
  return res.data;
};

export const getCompletedCourses = async (): Promise<
  CompletedCourses | undefined
> => {
  const res = await api.get(`/realities/${realityId}/completed-courses`);
  return res.data;
};

export type PdcSyncSkipReasons = {
  invalidPdcCourseId: number;
  noRealityCourse: number;
  hasFinalExamGrade: number;
};

export type PdcSyncResponse = {
  updated: number;
  skipped: number;
  skipReasons: PdcSyncSkipReasons;
};

/** Persists PDC list progress into Nest `user_course_progress` (server calls sg-pdc-api). */
export const syncPdcCourseProgress = async (): Promise<PdcSyncResponse> => {
  const res = await api.post(`/realities/${realityId}/courses/pdc/sync`);
  return res.data as PdcSyncResponse;
};

/**
 * Syncs PDC → Nest `user_course_progress`, then invalidates inscription/course caches
 * (including `get-courses-pdc`). Use on dashboard, /courses, tab visibility, embed close.
 */
export async function syncPdcCourseProgressToRealityThenRefreshQueries(): Promise<void> {
  try {
    await syncPdcCourseProgress();
  } catch {
    /* Nest/PDC unavailable */
  }
  await invalidateRegistrationProgressQueries();
}
